import React from 'react';
import Card from './Card';
import Overlay from './Overlay';
import OverlayTabContent from './OverlayTabContent';
import OverlayTabs from './OverlayTabs';

class Compendium extends React.Component
{
    constructor(props)
    {
        super(props);
        this.state = {
            activeTab: "decklist"
        }
        this.chooseTab = this.chooseTab.bind(this);
    }

    chooseTab(name)
    {
        this.setState({
            activeTab: name
        })
    }

    formatTabData()
    {
        return [
            {
                "name": "decklist",
                "title": "Decklist",
                "isActive": this.state.activeTab === 'decklist'
            },
            {
                "name": "artifacts",
                "title": "Artifacts",
                "isActive": this.state.activeTab === 'artifacts'
            },
            {
                "name": "enemies",
                "title": "Enemies",
                "isActive": this.state.activeTab === 'enemies'
            }
        ];
    }

    render()
    {
        return (
            <Overlay
                overlayClasses="compendium-overlay"
                title="Compendium"
                display={this.props.display}
                closeOverlay={this.props.closeOverlay}
                name='compendium'
                key='compendium'
                >
                <div className="compendium-wrapper">
                    <OverlayTabs
                        chooseTab={this.chooseTab}
                        tabData={this.formatTabData()}
                        key="tabs"
                        />
                    <OverlayTabContent
                        isActive={this.state.activeTab === 'artifacts'}
                        key="artifacts"
                        withBorder={true}
                    >
                        <div className="artifact-previews">
                            {this.props.artifacts.map(
                                artifactData => {
                                    return (
                                        <div id={artifactData.uid} key={'artifact_' + artifactData.uid} className="artifact-preview">
                                            <img src={artifactData.image} title={artifactData.description} className="artifact-preview__image" />
                                            <h3 className="artifact-preview__name">{artifactData.name}</h3>
                                            <p className="artifact-preview__description">{artifactData.description}</p>
                                            {
                                                artifactData.unlockLevel > this.props.experience.level
                                                ? (
                                                    <div className="artifact-preview__locked">
                                                        <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M8.1819 10.7027H6.00008C5.44781 10.7027 5.0001 11.1485 5.00009 11.7008C5.00005 13.3483 5 16.6772 5.00011 18.9189C5.00023 21.4317 8.88618 22 12 22C15.1139 22 19 21.4317 19 18.9189C19 16.6773 19 13.3483 19 11.7008C19 11.1485 18.5523 10.7027 18 10.7027H15.8182M8.1819 10.7027C8.1819 10.7027 8.18193 8.13514 8.1819 6.59459C8.18186 4.74571 9.70887 3 12 3C14.2912 3 15.8182 4.74571 15.8182 6.59459C15.8182 8.13514 15.8182 10.7027 15.8182 10.7027M8.1819 10.7027H15.8182" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M13 16.6181V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V16.6181C10.6931 16.3434 10.5 15.9442 10.5 15.5C10.5 14.6716 11.1716 14 12 14C12.8284 14 13.5 14.6716 13.5 15.5C13.5 15.9442 13.3069 16.3434 13 16.6181Z" fill="#ffffff"/>
                                                        </svg>
                                                        <span>Unlock at level {artifactData.unlockLevel}</span>
                                                    </div>
                                                )
                                                : (
                                                    <></>
                                                )
                                            }
                                        </div>
                                    )
                                }
                            )}
                        </div>
                    </OverlayTabContent>
                    <OverlayTabContent
                        isActive={this.state.activeTab === 'decklist'}
                        key="decklist"
                        withBorder={true}
                    >
                        <div className="cards">
                            {this.props.cards.map((card, handPos) => {
                                let cardJsx =
                                    <Card
                                        id={card.id}
                                        key={card.uid}
                                        uid={card.uid}
                                        name={card.name}
                                        image={card.image}
                                        description={card.description}
                                        tier={card.tier}
                                        cost={card.cost}
                                        goldCost={card.goldCost}
                                        unlockLevel={card.unlockLevel}
                                        isUnlocked={card.unlockLevel <= this.props.experience.level}
                                        playCard={() => {}}
                                        addUnplayableClass={false} />

                                if (this.props.cta && this.props.action) {
                                    return (
                                        <div class="card-with-cta" key={"card-wrapper-" + card.uid}>
                                            {cardJsx}
                                            <button class="card-cta" onClick={() => this.props.action(card.uid)}>{this.props.cta}</button>
                                        </div>
                                    );
                                }
                                return cardJsx;
                            })}
                        </div>
                    </OverlayTabContent>
                    <OverlayTabContent
                        isActive={this.state.activeTab === 'enemies'}
                        key="enemies"
                        withBorder={true}
                    >
                        <div className="enemy-previews">
                            {this.props.enemies.map(
                                enemyData => {
                                    if (enemyData.id === 34) {
                                        // Mimic
                                        return (<div key="null"></div>);
                                    }
                                    return (
                                        <div id={enemyData.id} key={'enemy_' + enemyData.id} className="enemy-preview">
                                            <img src={enemyData.image} title={enemyData.description} className="enemy-preview__image" />
                                            <h3 className="enemy-preview__name">{enemyData.name}</h3>
                                            <p className="enemy-preview__description">{enemyData.description}</p>
                                            <p className="enemy-preview__details">
                                                <span>Level: {enemyData.level}</span>
                                                <span>Health: {enemyData.hp}</span>
                                                <span>Card Draw: {enemyData.cardDraw}</span>
                                                <span>Gold: {enemyData.gold}</span>
                                                <span>Special Effect: {enemyData.effectDescription}</span>
                                            </p>
                                            {
                                                enemyData.unlockLevel > this.props.experience.level
                                                ? (
                                                    <div className="enemy-preview__locked">
                                                        <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                            <path d="M8.1819 10.7027H6.00008C5.44781 10.7027 5.0001 11.1485 5.00009 11.7008C5.00005 13.3483 5 16.6772 5.00011 18.9189C5.00023 21.4317 8.88618 22 12 22C15.1139 22 19 21.4317 19 18.9189C19 16.6773 19 13.3483 19 11.7008C19 11.1485 18.5523 10.7027 18 10.7027H15.8182M8.1819 10.7027C8.1819 10.7027 8.18193 8.13514 8.1819 6.59459C8.18186 4.74571 9.70887 3 12 3C14.2912 3 15.8182 4.74571 15.8182 6.59459C15.8182 8.13514 15.8182 10.7027 15.8182 10.7027M8.1819 10.7027H15.8182" stroke="#ffffff" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                                                            <path fillRule="evenodd" clipRule="evenodd" d="M13 16.6181V18C13 18.5523 12.5523 19 12 19C11.4477 19 11 18.5523 11 18V16.6181C10.6931 16.3434 10.5 15.9442 10.5 15.5C10.5 14.6716 11.1716 14 12 14C12.8284 14 13.5 14.6716 13.5 15.5C13.5 15.9442 13.3069 16.3434 13 16.6181Z" fill="#ffffff"/>
                                                        </svg>
                                                        <span>Unlock at level {enemyData.unlockLevel}</span>
                                                    </div>
                                                )
                                                : (
                                                    <></>
                                                )
                                            }
                                        </div>
                                    )
                                })
                            };
                        </div>
                    </OverlayTabContent>
                </div>
            </Overlay>
        );
    }
}

export default Compendium;
